import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';
const unlock = createElement(SVG, {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, createElement(Path, {
  d: "M18 9h-2V5c0-1.7-1.3-3-3-3h-2C9.3 2 8 3.3 8 5v1h1.5V5c0-.8.7-1.5 1.5-1.5h2c.8 0 1.5.7 1.5 1.5v4H6c-1.3 0-2 1-2 2v8c0 1 .7 2 2 2h12c1.3 0 2-1 2-2v-8c0-1-.7-2-2-2z"
}));
export default unlock;
//# sourceMappingURL=unlock.js.map